module.exports = __webpack_public_path__ + "static/media/backPattern.79615ff5.jpg";